import './blog.css';

import HeaderBlog from './HeaderBlog';

const featuredPost = {

  title: 'ContaLearn: o noua experienta de invatare a contabilitatii',
 
  href: '/blogposts/cum-sa-inveti-contabilitate.html',
};

const blogPosts = [
  {
    date: '23 mar 2026',
    title: 'Contul 201 "Cheltuieli de constituire" - tratament contabil complet',
    author: 'De echipa ContaLearn',
    href: '/blogposts/cont-201-cheltuieli-de-constituire.html',
  },
  {
    date: '20 aug 2024',
    title: 'Bilantul contabil explicat simplu, cu exemple practice',
    author: 'De echipa ContaLearn',
    href: '/blogposts/cum-sa-inveti-contabilitate.html',
  },
  {
    date: '17 aug 2024',
    title: 'Cum intelegi mai rapid activele, pasivele si capitalurile',
    author: 'De echipa ContaLearn',
    href: '/blogposts/top-5-greseli-incepatori.html',
  },
  {
    date: '10 aug 2024',
    title: 'Balanta de verificare: pasi clari pentru incepatori',
    author: 'De echipa ContaLearn',
    href: '/blogposts/cum-sa-inveti-contabilitate.html',
  },
  {
    date: '03 aug 2024',
    title: 'Dubla inregistrare explicata simplu, fara formule complicate',
    author: 'De echipa ContaLearn',
    href: '/blogposts/top-5-greseli-incepatori.html',
  },
];

const Blog = () => {
  return (
    <div className='blog-page'>

         <HeaderBlog />

      <section className='blog-featured'>
        <div className='blog-featured-content'>
       

          <p className='blog-featured-label'>{featuredPost.label}</p>
          <h1 className='blog-featured-title'>{featuredPost.title}</h1>
          <p className='blog-featured-author-main' id='authors'>{featuredPost.author}</p>
          <a className='blog-read-more' href={featuredPost.href}>Citeste articolul</a>
        </div>
      </section>

      <section className='blog-grid-section' id='posts'>
        <div className='blog-grid'>
          {blogPosts.map((post) => (
            <article className='blog-card' key={post.title}>
              <p className='blog-card-date'>{post.date}</p>
              <h2 className='blog-card-title'>
                <a href={post.href}>{post.title}</a>
              </h2>
              <p className='blog-card-author'>{post.author}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Blog;